import React from "react";


import { createBottomTabNavigator } from '@react-navigation/bottom-tabs';

import MaterialCommunityIcons from 'react-native-vector-icons/MaterialCommunityIcons';

import { Feather } from '@expo/vector-icons';
import { FontAwesome } from '@expo/vector-icons';
import { MaterialIcons } from '@expo/vector-icons';
import { SimpleLineIcons } from '@expo/vector-icons';
import { Ionicons } from '@expo/vector-icons';
import { FontAwesome5 } from '@expo/vector-icons';
import { Fontisto } from '@expo/vector-icons';
const Tab = createBottomTabNavigator();







import { RFPercentage, RFValue } from "react-native-responsive-fontsize";

import Welcome from "./Tab/HomeScreen";
import Hometab from "./Tab/Hometab";


import T from './Tab/t';
import D from './Tab/d';
import Wallet from "./Tab/Wallet";
import Mission from "./Tab/Mission";
import Profile from "./Tab/Profile";
import Package from "./Tab/Package";


const Home = (props)=>{



    return (
        <Tab.Navigator
            screenOptions={{
                headerShown : false,
                tabBarShowLabel: true,
                tabBarActiveTintColor: '#00ffb3',
                tabBarInactiveTintColor: '#e1e1e1',

                tabBarStyle: {
                    backgroundColor: '#19222f',
                    height : RFValue(60)
                },
                tabBarLabelStyle: {
                    fontSize: RFValue(9),
                    // fontWeight: "bold",
                    margin : 0,
                    padding : 0,
                    fontFamily : 'novaria'
                }

            }}

        >

            <Tab.Screen options={{
                tabBarLabel: 'Home',



                tabBarIcon: ({ color, size, focused }) => (
                    <MaterialCommunityIcons
                        name="home"
                        color={ focused ? '#FFF':'#FFF'}
                        size={ focused ? RFValue(size + 2) : RFValue(size - 2)}
                    />
                ),


                // tabBarBadge: 3,
            }} name="Hometab" component={Hometab} />


            <Tab.Screen options={{
                tabBarLabel: 'My package',

                tabBarIcon: ({ color, size, focused }) => (
                    <MaterialCommunityIcons name="package"
                              color={ focused ? '#FFF':'#FFF'}
                              size={ focused ? RFValue(size + 2) : RFValue(size - 2)}
                    />

                ),


                // tabBarBadge: 3,
            }} name="Package" component={Package} />


            {/*<Tab.Screen options={{*/}
            {/*    tabBarLabel: 'Mission',*/}

            {/*    tabBarIcon: ({ color, size, focused }) => (*/}
            {/*        <FontAwesome5 name="network-wired"*/}
            {/*                  color={ focused ? '#FFF':'#FFF'}*/}
            {/*                  size={ focused ? RFValue(size + 2) : RFValue(size - 2)}*/}
            {/*        />*/}
            {/*    ),*/}



            {/*    // tabBarBadge: 3,*/}
            {/*}} name="Mission" component={Mission} />*/}






            <Tab.Screen options={{
                tabBarLabel: 'Wallet',

                tabBarIcon: ({ color, size, focused }) => (
                    <Ionicons name="md-wallet-sharp"
                              color={ focused ? '#FFF':'#FFF'}
                                 size={ focused ? RFValue(size + 2) : RFValue(size - 2)}
                    />
                ),



                // tabBarBadge: 3,
            }} name="Wallet" component={Wallet} />


            <Tab.Screen options={{
                tabBarLabel: 'Personal',

                tabBarIcon: ({ color, size, focused }) => (
                    <FontAwesome name="user"
                                 color={ focused ? '#FFF':'#FFF'}
                                            size={ focused ? RFValue(size + 2) : RFValue(size - 2)}
                    />
                ),


                // tabBarBadge: 3,
            }} name="Profile" component={Profile} />




        </Tab.Navigator>
    );






}



export default Home;
